import { useMemo } from "react";
import type { Column } from "@tanstack/react-table";
import type { FilterConfig } from "../types";

export const useFilterConfig = (columns: Column<any, unknown>[]): FilterConfig[] =>
    useMemo(() => columns
        .filter((column) => column.columnDef.enableColumnFilter === true)
        .map((column) => ({
            name: column.id,
            label: typeof column.columnDef.header === "string" ? column.columnDef.header : column.id,
            type: column.columnDef.filterType,
            component: column.columnDef.filter,
        })), [columns]);
